export const getUiBlocksData = async () => {
  try {
    const response = await fetch('https://wp.bala.bokeylibrary.kz/wp-content/themes/main/data/get_data.php?file=ui_blocks');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error ui blocks', error);
    return [];
  }
};
